import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import PropertyCard from "./PropertyCard";
import TopPropertyCard from "./TopPropertyCard";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

/** @param {"default" | "listings" | "projects"} variant */
const CustomLeftArrow = ({ onClick, variant = "default" }) => {
  if (variant === "default") {
    return (
      <button
        type="button"
        onClick={onClick}
        className="custom-arrow custom-left-arrow absolute left-0 top-1/2 z-20 ml-4 -translate-y-1/2 transform rounded-full border-2 border-gray-300 bg-transparent p-3 transition-all duration-300 hover:border-gray-400 hover:bg-gray-200"
        style={{
          marginRight: "0px",
          backgroundColor: "#0f172ad4",
          marginLeft: "0px",
          color: "#fff",
        }}
      >
        <IoIosArrowBack size={24} />
      </button>
    );
  }

  const isProjects = variant === "projects";
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Previous"
      className={`custom-arrow custom-left-arrow absolute left-1 top-1/2 z-20 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border shadow-md transition md:left-2 md:h-10 md:w-10 ${
        isProjects
          ? "border-slate-600 bg-[#0F172A] text-white hover:bg-slate-800"
          : "border-slate-200/90 bg-white text-[#0F172A] hover:border-[#FECE51] hover:bg-amber-50"
      }`}
    >
      <IoIosArrowBack size={20} />
    </button>
  );
};

const CustomRightArrow = ({ onClick, variant = "default" }) => {
  if (variant === "default") {
    return (
      <button
        type="button"
        onClick={onClick}
        className="custom-arrow custom-right-arrow absolute right-0 top-1/2 z-20 mr-4 -translate-y-1/2 transform rounded-full border-2 border-gray-300 bg-transparent p-3 transition-all duration-300 hover:border-gray-400 hover:bg-gray-200"
        style={{
          marginRight: "20px",
          backgroundColor: "#0f172ad4",
          marginLeft: "0px",
          color: "#fff",
        }}
      >
        <IoIosArrowForward size={24} />
      </button>
    );
  }

  const isProjects = variant === "projects";
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Next"
      className={`custom-arrow custom-right-arrow absolute right-1 top-1/2 z-20 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border shadow-md transition md:right-2 md:h-10 md:w-10 ${
        isProjects
          ? "border-slate-600 bg-[#0F172A] text-white hover:bg-slate-800"
          : "border-slate-200/90 bg-white text-[#0F172A] hover:border-[#FECE51] hover:bg-amber-50"
      }`}
    >
      <IoIosArrowForward size={20} />
    </button>
  );
};

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

function MultiCrousel({ data, autoplay, details, carouselVariant = "default" }) {
  const dotListClass =
    carouselVariant === "listings"
      ? "custom-dot-list-style home-carousel-dots--listings"
      : carouselVariant === "projects"
        ? "custom-dot-list-style home-carousel-dots--projects"
        : "custom-dot-list-style";

  return (
    <div className="relative">
      <Carousel
        swipeable={true}
        draggable={true}
        ssr={true}
        infinite={true}
        autoPlay={autoplay !== false}
        autoPlaySpeed={7000}
        keyBoardControl={true}
        customTransition="transform 300ms ease-in-out"
        transitionDuration={300}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        dotListClass={dotListClass}
        itemClass="carousel-item-padding-40-px"
        responsive={responsive}
        className="z-10"
        customLeftArrow={<CustomLeftArrow variant={carouselVariant} />}
        customRightArrow={<CustomRightArrow variant={carouselVariant} />}
      >
        {data.map((item) =>
          details ? (
            <PropertyCard key={item.key} card={item} />
          ) : (
            <TopPropertyCard key={item.key ?? item.id} card={item} />
          )
        )}
      </Carousel>
    </div>
  );
}

export default MultiCrousel;
